import { clients } from '@oncolens/oncolens-ui/lib/api/client';
import { useQuery } from 'react-query';
import { License } from '../types/index';
import { OrganizationKeys } from './organization.keys';

export const getOrganizationHasLicense = async (id: string, license: License) => {
  const response = await clients.admin.get(`/organizations/${id}/hasLicense?license=${license}`);
  return response.data as boolean;
};

export const useOrganizationHasLicense = (id: string | undefined, license: License) => {
  const definiteOrganizationId = id?.toString() ?? '';
  return useQuery(
    OrganizationKeys.license(definiteOrganizationId, license),
    () => getOrganizationHasLicense(definiteOrganizationId, license),
    {
      enabled: id !== undefined,
    },
  );
};
